const devConfig = {
  API_BASE_URL: 'http://localhost:4002/api',
};

const betaConfig = {
  API_BASE_URL: 'https://booking.api.beta.rishikesh.app/api',
};

const previewConfig = {
  API_BASE_URL: process.env.VUE_APP_API_BASE_URL || 'https://booking.api.dev.rishikesh.app/api',
};

const prodConfig = {
  API_BASE_URL: 'https://booking.api.rishikesh.app/api',
};

const effectiveConfig = () => {
  switch (process.env.VUE_APP_MODE) {
    case 'development':
      return devConfig;
    case 'preview':
      return previewConfig;
    case 'beta':
      return betaConfig;
    case 'production':
      return prodConfig;
    default:
      return devConfig;
  }
};

export default effectiveConfig();
